module.exports = __webpack_public_path__ + "static/img/Doit-04.ad08a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Doit-04.png
// module id = lxsP
// module chunks = 0